import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function budgetValidator(budget: number, max?: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (Number(control.value) < budget) {
            return { amountLowerThanBudget: { budget } };
        }

        if (max && Number(control.value) > max) {
            return { amountTooHigh: { max } };
        }

        return null;
    };
}
